// extracted by mini-css-extract-plugin
module.exports = {"headerBlock":"HeaderBlock_headerBlock__PEHEy","headerBlock__logoBlock":"HeaderBlock_headerBlock__logoBlock__TwX9I","headerBlock__inner":"HeaderBlock_headerBlock__inner__JtlXR"};